import { z } from 'zod';
import { BaseSchema } from './baseSchema';

export const PhotosSchema = BaseSchema.extend({
    identify_image: z.string(),
    identify_image_caption: z.string().nullable(),
});

export const DocumentsSchema = BaseSchema.extend({
    identify_image: z.string(),
    identify_image_caption: z.string().nullable(),
});
